/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionDto } from './QuestionDto';
import {
    QuestionDtoFromJSON,
    QuestionDtoFromJSONTyped,
    QuestionDtoToJSON,
    QuestionDtoToJSONTyped,
} from './QuestionDto';
import type { ReferentialDto } from './ReferentialDto';
import {
    ReferentialDtoFromJSON,
    ReferentialDtoFromJSONTyped,
    ReferentialDtoToJSON,
    ReferentialDtoToJSONTyped,
} from './ReferentialDto';

/**
 * 
 * @export
 * @interface SurveyDetailDto
 */
export interface SurveyDetailDto {
    /**
     * Survey unique identifier
     * @type {string}
     * @memberof SurveyDetailDto
     */
    id?: string;
    /**
     * Survey name
     * @type {string}
     * @memberof SurveyDetailDto
     */
    name?: string;
    /**
     * Survey description
     * @type {string}
     * @memberof SurveyDetailDto
     */
    description?: string | null;
    /**
     * Survey version number
     * @type {number}
     * @memberof SurveyDetailDto
     */
    version?: number;
    /**
     * Whether the survey is active
     * @type {boolean}
     * @memberof SurveyDetailDto
     */
    isActive?: boolean;
    /**
     * Associated branch ID
     * @type {string}
     * @memberof SurveyDetailDto
     */
    branchId?: string | null;
    /**
     * Associated branch name
     * @type {string}
     * @memberof SurveyDetailDto
     */
    branchName?: string | null;
    /**
     * Context ID
     * @type {string}
     * @memberof SurveyDetailDto
     */
    contextId?: string;
    /**
     * 
     * @type {ReferentialDto}
     * @memberof SurveyDetailDto
     */
    context?: ReferentialDto;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof SurveyDetailDto
     */
    creationTime?: Date;
    /**
     * Last modification timestamp
     * @type {Date}
     * @memberof SurveyDetailDto
     */
    lastModificationTime?: Date | null;
    /**
     * Username of the creator
     * @type {string}
     * @memberof SurveyDetailDto
     */
    creatorUserName?: string | null;
    /**
     * Number of questions in the survey
     * @type {number}
     * @memberof SurveyDetailDto
     */
    questionCount?: number;
    /**
     * Number of eligibility rules
     * @type {number}
     * @memberof SurveyDetailDto
     */
    eligibilityRulesCount?: number;
    /**
     * List of questions (included when requested)
     * @type {Array<QuestionDto>}
     * @memberof SurveyDetailDto
     */
    questions?: Array<QuestionDto> | null;
}

/**
 * Check if a given object implements the SurveyDetailDto interface.
 */
export function instanceOfSurveyDetailDto(value: object): value is SurveyDetailDto {
    return true;
}

export function SurveyDetailDtoFromJSON(json: any): SurveyDetailDto {
    return SurveyDetailDtoFromJSONTyped(json, false);
}

export function SurveyDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'version': json['version'] == null ? undefined : json['version'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'branchName': json['branchName'] == null ? undefined : json['branchName'],
        'contextId': json['contextId'] == null ? undefined : json['contextId'],
        'context': json['context'] == null ? undefined : ReferentialDtoFromJSON(json['context']),
        'creationTime': json['creationTime'] == null ? undefined : (new Date(json['creationTime'])),
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : (new Date(json['lastModificationTime'])),
        'creatorUserName': json['creatorUserName'] == null ? undefined : json['creatorUserName'],
        'questionCount': json['questionCount'] == null ? undefined : json['questionCount'],
        'eligibilityRulesCount': json['eligibilityRulesCount'] == null ? undefined : json['eligibilityRulesCount'],
        'questions': json['questions'] == null ? undefined : ((json['questions'] as Array<any>).map(QuestionDtoFromJSON)),
    };
}

export function SurveyDetailDtoToJSON(json: any): SurveyDetailDto {
    return SurveyDetailDtoToJSONTyped(json, false);
}

export function SurveyDetailDtoToJSONTyped(value?: SurveyDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'version': value['version'],
        'isActive': value['isActive'],
        'branchId': value['branchId'],
        'branchName': value['branchName'],
        'contextId': value['contextId'],
        'context': ReferentialDtoToJSON(value['context']),
        'creationTime': value['creationTime'] == null ? undefined : ((value['creationTime']).toISOString()),
        'lastModificationTime': value['lastModificationTime'] == null ? undefined : ((value['lastModificationTime'] as any).toISOString()),
        'creatorUserName': value['creatorUserName'],
        'questionCount': value['questionCount'],
        'eligibilityRulesCount': value['eligibilityRulesCount'],
        'questions': value['questions'] == null ? undefined : ((value['questions'] as Array<any>).map(QuestionDtoToJSON)),
    };
}

